import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gold serif text-2xl">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
